import { IAcceptProvenances } from '../../../actions/provenances/loadProvenances'
import { IProvenancesStore } from '../index'

export default function(
  store: IProvenancesStore,
  action: IAcceptProvenances,
): IProvenancesStore {
  return {
    ...store,
    provenances: action.provenances,
    request: {
      ...store.request,
      errMessage: '',
      isLoading: false,
    },
  }
}
